import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useUpdateCategoryMutation } from "../../../../../../API/authApi";
import { useDirectoriesHook, useToastify } from "../../../../../../Hooks/hooks";
import { IAutocompleteItem, ImageTypes, MenuCategoryTypes } from "../../../../../../Interfaces/componentTypes";
import { IUpdateCreatedCategoryForm } from "../../../../../../Interfaces/formValue-interfaces";
import { IUpdateCategory } from "../../../../../../Interfaces/request-interfaces";
import useUploadFile from "../../../../../../Components/FileUploader/fileUploader-hooks";
import { IEditCategoryProps } from "./editCategoryDialog";
import useLanguagesHooks from "../../../../../../Components/Languages/setLanguage-hooks";

const useEditCategory = (props: IEditCategoryProps) => {
    const { data, compnay_id, onClose, cb } = props;
    const { t } = useLanguagesHooks();
    const { default_image, upload_image, is_author } = data;
    const { menuTypeOptions } = useDirectoriesHook();
    const [showTranslations, setShowTranslations] = useState<boolean>(false);
    const [update, { isLoading: updateLoading, isSuccess: updateSuccess, isError: updateError }] = useUpdateCategoryMutation();
    const {
        register,
        control,
        formState: { errors, isValid },
        setValue,
        getValues,
    } = useForm<IUpdateCreatedCategoryForm>();
    const { imageUrl, handleFileInputChange, ImageResponce, imageLoading } = useUploadFile(ImageTypes.CATEGORY);
    const defaultImage = upload_image ? upload_image : default_image;
    const [validation, setValidation] = useState<boolean>(false);

    useEffect(() => {
        setValidation(isValid);
    }, [isValid]);

    useEffect(() => {
        ImageResponce?.src  && setValidation(true);
    }, [ImageResponce]);

    const dialogRef = useRef<HTMLDivElement | null>(null);
    const { showToastSuccess, showToastError } = useToastify();

    const handleShowTranslations = () => {
        setShowTranslations(prev => !prev)
    };

    useEffect(() => {
        if (is_author) {
            const menuType = menuTypeOptions.filter((type) => type.id === data.menu_type)[0];
            setValue('name_hy', data.name_hy);
            setValue('name_ru', data.name_ru);
            setValue('name_en', data.name_en);
            setValue('menu_type', menuType as IAutocompleteItem)
        }
    }, [is_author]);

    useEffect(() => {
        if (updateSuccess) {
            showToastSuccess(t('Toast.Success.Common'));
            cb();
            onClose();
        } else if (updateError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [updateSuccess, updateError])

    const onUpdate = () => {
        if (data.is_author) {
            const payload: IUpdateCategory = {
                company_id: compnay_id,
                category_id: data.id,
                name_hy: getValues('name_hy'),
                name_en: getValues('name_en'),
                name_ru: getValues('name_ru'),
                default_image: ImageResponce?.src ?? defaultImage,
                menu_type: getValues('menu_type').id as MenuCategoryTypes,
            };
            update(payload)
        } else {
            const payload: IUpdateCategory = {
                company_id: compnay_id,
                category_id: data.id,
                upload_image: ImageResponce?.src ?? defaultImage,
            };
            update(payload)
        }
    };

    return {
        errors,
        control,
        imageUrl,
        dialogRef,
        validation,
        defaultImage,
        imageLoading,
        updateLoading,
        menuTypeOptions,
        showTranslations,
        register,
        onUpdate,
        handleFileInputChange,
        handleShowTranslations,
    }
};

export default useEditCategory;
